import React, { useState } from "react";
import { Menu, MenuItem, Button, Box,Typography } from "@mui/material";
import serviceTaskRunner, { services, _callRestfulService as restful } from "../../lib/restful/services/restAPIs";

const CheckoutSession = ({products, setPaymentLink, setShowPayment, instructRef}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleUpgradeClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handlePlanSelect = async (plan) => {
  
    if(plan.pricePlanId==="price_freemium") return true;

    let _SignUpTaskRunner = await serviceTaskRunner(services.CUSTOMER_CHECKOUT)(
        {plan:plan.plan,
        pricePlan:plan.pricePlan,
        pricePlanId:plan.pricePlanId}
        ,
        async (response, callParams) => {
          //callBack function
          //Get return data from the restufl call
          const data = response.data.payload;
          let result = data;
         
          instructRef.current=(<>   
          <Typography variant="body1" sx={{ textAlign: "center" }}>
              We're now directing you to set up your subscription plan.
          </Typography>
          <Typography variant="body1" sx={{ mt: 2, textAlign: "center" }}>
              If you don’t complete the payment setup for any reason, no worries! You can log in anytime with your freemium account and use the <strong>UPGRADE</strong> option to finalize your subscription.
          </Typography></>);
          setPaymentLink(data.url); 
          setShowPayment(true) ;
          return result;
        },
        {
          //callBack Parameters
        },
        (error) => {

          //console.log(error);
          handleMenuClose();
         // throw { message: "Unable to to signup user." };
        }
      );

      handleMenuClose();
  
    
    
  };

  return (
    <Box sx={{ p: 1, maxWidth: 100,  textAlign: "center" }}>
      <Button variant="contained" color="primary" onClick={handleUpgradeClick}>
        UPGRADE
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        {products.filter((plan)=>plan.title!="Individual Minimalist").map((plan) => (
          <MenuItem key={plan.pricePlanId} onClick={async () => {await handlePlanSelect(plan)}}>
            {plan.title} ({plan.price.join(" ")})
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default CheckoutSession;
